export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_RESPONSE = "LOGIN_RESPONSE";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";

export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";

export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";

export const IS_USER_FORCED_LOGOUT_REQUEST =
  "IS_USER_FORCED_LOGOUT_REQUEST";
export const IS_USER_FORCED_LOGOUT_RESPONSE =
  "IS_USER_FORCED_LOGOUT_RESPONSE";
export const FORCE_LOGOUT_REQUEST = "FORCE_LOGOUT_REQUEST";
